import React, { createContext, useContext, useState, useEffect } from 'react';
import nl from '../../lang/nl.json';
import en from '../../lang/en.json';

const LanguageContext = createContext();
const translations = { nl, en };

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('language') || 'en';
    });

    useEffect(() => {
        localStorage.setItem('language', language);
    }, [language]);

    useEffect(() => {
        const handleStorageChange = () => {
            const storedLanguage = localStorage.getItem('language');
            if (storedLanguage && storedLanguage !== language) {
                setLanguage(storedLanguage);
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [language]);

    const translate = (key) => {
        return translations[language][key] || key;
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, translate }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useTranslation = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useTranslation must be used within a LanguageProvider');
    }
    return context;
};

export const TranslateString = ({ stringKey, className }) => {
    const { translate } = useTranslation();
    return <span className={className}>{translate(stringKey)}</span>;
};
